import axios from 'axios'
import { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { SvgIcon, SvgType } from '../../common/svgIcon/SvgIcon'
import appConfig from '../../config'
import routes, { externalRoutes } from '../../routes'
import { LiveSessionType } from '../../slices/sessionSlice'
import { LiveCard } from './styled'

const LiveSessionCard = ({
  liveSession,
  setSpeakers,
  ended = false,
}: {
  liveSession: LiveSessionType
  setSpeakers: any
  ended?: boolean
}) => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleJoin = (e: any) => {
    e.preventDefault()
    setLoading(true)
    axios
      .post(`${appConfig.API_URL}/live_sessions/${liveSession.id}/join`)
      .then((res) => {
        if (res.data.success) {
          navigate(routes.joinSession, {
            state: {
              liveSessionId: liveSession.id,
            },
          })
        } else {
          toast(res.data.message)
        }
      })
      .catch((err) => {
        toast(err.message)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  return (
    <LiveCard>
      {liveSession.hasAccess || (
        <div className="lockOverlay">
          <div className="lock">
            <SvgIcon type={SvgType.LOCK} />
            <div>Premium</div>
          </div>
        </div>
      )}

      {ended && (
        <div className="lockOverlay">
          <div className="ended">
            <div>Ended</div>
          </div>
        </div>
      )}

      {liveSession.thumbnail ? (
        <img
          className="sessionThumbnail"
          src={liveSession.thumbnail}
          alt={liveSession.title}
          width={'100%'}
        />
      ) : (
        <div className="cardPlaceholder"></div>
      )}
      <footer className="cardFooter">
        <div>
          <div className="text-white date">
            {liveSession.date} | {liveSession.day}{' '}
          </div>
          <div className="text-white time">
            {liveSession.startTime} - {liveSession.endTime}{' '}
          </div>
        </div>
        <Dropdown drop="up">
          <Dropdown.Toggle size="sm" className="addToCalBtn">
            <SvgIcon type={SvgType.ADD} />
            <span className="ms-1">Add To Calendar</span>
          </Dropdown.Toggle>

          <Dropdown.Menu variant="dark">
            <Dropdown.Item
              target="_blank"
              href={liveSession.calendar.ics}
              eventKey="ics"
            >
              iCal File
            </Dropdown.Item>
            <Dropdown.Item
              target="_blank"
              href={liveSession.calendar.google}
              eventKey="google"
            >
              Google
            </Dropdown.Item>
            <Dropdown.Item
              target="_blank"
              href={liveSession.calendar.office365}
              eventKey="office365"
            >
              Office365
            </Dropdown.Item>
            <Dropdown.Item
              target="_blank"
              href={liveSession.calendar.outlook}
              eventKey="outlook"
            >
              Outlook
            </Dropdown.Item>
            <Dropdown.Item
              target="_blank"
              href={liveSession.calendar.yahoo}
              eventKey="yahoo"
            >
              Yahoo
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </footer>
      <div className="overlay">
        {/* <button className="btn btn-outline-info">View Speaker</button> */}
        {liveSession.presenters.length ? (
          <button
            className="btn btn-outline-warning"
            onClick={() => {
              setSpeakers(liveSession.presenters)
            }}
          >
            VIEW SPEAKER
          </button>
        ) : null}
        {!ended && (
          <>
            {liveSession.hasAccess ? (
              <Link
                to={`${liveSession.id}`}
                className={`btn btn-outline-danger ${
                  loading ? 'disabled' : ''
                }`}
                onClick={handleJoin}
              >
                {loading ? 'JOINING...' : 'JOIN NOW'}
              </Link>
            ) : (
              <a
                target="_blank"
                rel="noreferrer"
                href={externalRoutes.dashboard}
                className={`btn btn-outline-danger ${
                  loading ? 'disabled' : ''
                }`}
              >
                GO PREMIUM
              </a>
            )}
          </>
        )}
      </div>
    </LiveCard>
  )
}

export default LiveSessionCard
